import React, { useEffect, useRef } from "react";
import styled from "styled-components";

// HH:MM (00~23 : 00~59) 형식 검증용 정규식 //
const TimeRegex = /^([01]\d|2[0-3]):[0-5]\d$/;

export default function TimeInput(props) {
  const { isEdit, value, setValue, placeholder } = props;

  const LastValidRef = useRef(TimeRegex.test(value) ? value : '00:00');

  // 유효한 값이 들어오면 마지막 유효값 갱신 (마운트/변경 시 보관) //
  useEffect(() => {
    if (TimeRegex.test(value)) LastValidRef.current = value;
  }, [value])

  // 시간 입력 변경 //
  function handleChange(e) {
    const regex = /^[0-9:\-\b]{0,11}$/;

    if (regex.test(e.target.value)) {
      if (e.target.value.length === 2) setValue(e.target.value.replace(/(\d{2})/, '$1:'));
      else if (e.target.value.length < 6) setValue(e.target.value);
    }
  }

  // 포커스 시 전체 선택 (입력하면 덮어쓰기, 미입력 시 기존 값 보존) //
  function handleFocus(e) {
    e.target.select();
  }

  // 블러 시 검증, HH:MM 형식이 아니면 마지막 유효값으로 복구 //
  function handleBlur(e) {
    if (!TimeRegex.test(value)) setValue(LastValidRef.current);
  }

  // 백스페이스 입력 처리 (구분자 ':' 위치 보정) //
  function handleKeyDown(e) {
    if (e.key === 'Backspace') {
      if (value.length === 3 || value.length === 6 || value.length === 9) {
        setValue(value.substring(0, value.length - 1));
      }
    }
  }

  return (
    <InputView border={isEdit ? '2px dashed #909090' : '2px solid #909090'}>
      <Input
        placeholder={placeholder}
        value={value}
        type='text'
        disabled={!isEdit}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown} />
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 88px;
  height: 28px;

  border: ${props => props.border};
  border-radius: 8px;
  background-color: #2F2F32;
`;

const Input = styled.input`
  font-family: NotoSansKR-Medium;
  font-size: 14px;
  line-height: 17px;

  width: 37px;
  height: 17px;

  padding: 0 0 0 0;
  margin: 0 0 0 0;

  outline: none;

  color: #FFFFFF;

  border: none;
  background-color: #2F2F32;

  ::placeholder {
    color: #ECECEC;
  }

  transition: all 0.3s ease-in-out;
`;
